import { useEffect, useLayoutEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
import ReactGA from "react-ga";

// Route side effects: scroll restore on Back/Forward, scroll to top on push,
// focus main content, page-view tracking (existing analytics integration).
export default function RouteManager() {
  const location = useLocation();
  const navType = useNavigationType();
  const positions = useRef({});
  const prevKey = useRef(location.key);

  useLayoutEffect(() => {
    positions.current[prevKey.current] = window.scrollY;
    prevKey.current = location.key;
    if (location.hash) {
      const target = document.getElementById(location.hash.slice(1));
      if (target) {
        target.scrollIntoView();
        return;
      }
    }
    if (location.state && location.state.preserveScroll) return;
    const y = navType === "POP" ? positions.current[location.key] || 0 : 0;
    window.scrollTo({ top: y, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [location, navType]);

  useEffect(() => {
    const main = document.getElementById("ro-main");
    if (main && navType !== "POP" && !(location.state && location.state.preserveScroll)) main.focus({ preventScroll: true });
    try {
      ReactGA.pageview(location.pathname + location.search);
    } catch (e) {
      /* analytics is optional */
    }
  }, [location, navType]);

  return null;
}
